<template lang="html">
<div class="order-view main">

  <!-- 订单信息： -->
  <div v-if="order.id" class="order-item fs2">
      <div class="clear pbm order-item__hd">
          <div class="left">
            <van-tag mark class="fs3 tag">基本信息</van-tag>
              <!-- <i class="iconfont">&#xe606;</i> {{ order.sn }} -->
          </div>
          <div class="right c6" :class="order.status">{{ orderStatusText[order.status] }}</div>
      </div>
      <div class="mtm pbm order-item__bd">
          <div class="clear mtn order-item__info">
              <div class="left c6">订单名称：购买《{{ order.title }}》</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">订单编号：{{ order.sn }}</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">下单时间：{{ createdtime }}</div>
          </div>
          <div v-if="order.paidTime" class="clear mtn order-item__info">
              <div class="left c6">支付时间：{{ paidtime }}</div>
          </div>
          <div v-if="payment" class="clear mtn order-item__info">
              <div class="left c6">支付方式：{{ payment }}</div>
          </div>
          <div v-if="order.cardInfo && order.cardInfo.endTime" class="clear mtn order-item__info">
              <div class="left red">到期时间：{{ endtime }}</div>
          </div>
          <div v-if="order.cardInfo && order.cardInfo.totalNum" class="clear mtn order-item__info">
              <div class="left red">剩余练球次数：{{order.cardInfo.remainingNum}}/{{order.cardInfo.totalNum}}</div>
          </div>
          <div v-if="order && order.courseStartTime" class="clear mtn order-item__info">
              <div class="left red">上课时间：{{ courseStartTime }}</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">订单类型：{{ ordertype }}</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c9"> <span v-show="ordertypeInfo"> 不支持</span>七天无理由退换货</div>
          </div>
          <div class="clear mtn order-item__price">
              <div class="right">合计：¥{{ order.amount }}</div>
          </div>
      </div>      
  </div>

  <!-- 俱乐部：显示 -->
  <div v-if="clubInfo" class="order-item fs2 mtm">
      <div class="clear pbm order-item__hd">
          <div class="left">
            <van-tag mark class="fs3 tag">俱乐部</van-tag>
          </div>
      </div>
      <div class="mtm pbm order-item__bd">
          <div class="clear mtn order-item__info">
              <div class="left c6">名称：
                <router-link :to="{ name: 'venue',params:{clubId:clubInfo.id}}" class="blue">{{clubInfo.title}}</router-link> 
              </div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">地址：{{ clubInfo.address }}</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">营业时间：{{ clubInfo.businessStartTime }}:00 ~ {{ clubInfo.businessEndTime }}:00</div>
          </div>
      </div>
  </div>
 
 <!-- 购买用户 -->
  <div v-if="clubInfo" class="order-item fs2 mtm">
      <div class="clear pbm order-item__hd">
          <div class="left">
            <van-tag mark class="fs3 tag">用户信息</van-tag>
          </div>
      </div>
      <div class="mtm pbm order-item__bd clear" @click="goTo(userInfo.id)">
        <avatar-box class="left" :avatar="userInfo.largeAvatar" :auth="userInfo.is_vip"></avatar-box>
        <div class="clear buyed-users__info">
            <div class="clear">
            <div class="left c4 fs2">{{ userInfo.nickname }}</div>
            </div>
            <!-- <div class="buyed-users__auth mtn fs1 c9">
            <span class="green">{{ userInfo.title }}</span>
            </div> -->
        </div>
      </div>
  </div>

  <!-- 操作 -->
  <div v-if="'refunding'==order.status" class="mtm clear order-item__ft buybar bcw">
    <div class="buybar__content clear">
      <the-refundbar :totalPrice="order.amount" :orderId="order.id" v-on:statusChanged="change($event)"></the-refundbar>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import { Toast,Tag,Step, Steps,Dialog  } from 'vant';
import Func from "@/assets/scripts/func";
import query from 'query-string';
import wx from 'weixin-js-sdk';
import moment from 'moment';
import AppointmentCard from '@/components/AppointmentCard';
import TheRefundbar from '@/components/TheRefundbar';
import AvatarBox from '@/components/AvatarBox'
moment.locale('zh-cn');
Vue.use(Toast).use(Tag).use(Step).use(Steps).use(Dialog)
export default {
  inject:['reload'],  //注入reload方法
  name: 'OrderView',
  components: {
    AppointmentCard,TheRefundbar,AvatarBox
  },
  data(){
    return {
      order: {},  // 订单信息
      clubInfo: {}, // 俱乐部信息
      userInfo:{},  //用户信息
      ordertypeInfo:false ,//是否支持7天退换
      orderStatusText: {
        'created': '待付款',
        'paid': '付款成功',
        'refunding': '申请退款中',
        'refunded': '已退款',
        'cancelled': '订单已取消'
      },
      active:{
        'created':0,
        'refunding':1,
        'success':2,
        'failed':2,
        'cancelled':1
      },  //退款步骤
      activeColor:{
        'created':'#06bf04',
        'refunding':'#06bf04',
        'success':'#06bf04',
        'failed':'#f60',
        'cancelled':'#06bf04'
      },
    }
  },
  created(){
    this.$nextTick(function () {
      let _this = this;
      this.$http.get('order_manage/getInfo?orderId='+this.$route.params.orderId).then(res => {
        this.order = res.data.value.orderInfo
        this.clubInfo = res.data.value.clubInfo
        this.userInfo = res.data.value.userInfo 
      }) 
    })   
  },
  methods: {
    change:function(sta){
        //子组件修改父组件值
        this.order.status = sta
    },    
    goTo:function(id){
      location.href=`${location.origin}`+'/training/#/userHome?userId='+id      
    }
  },
  computed: {
    createdtime: function () {
      return moment(this.order.createdTime*1000).format('YYYY-MM-DD HH:mm:ss')
    },
    paidtime: function () {
      return moment(this.order.paidTime*1000).format('YYYY-MM-DD HH:mm:ss')
    },
    endtime: function(){
      //月卡到期时间
      return moment(this.order.cardInfo['endTime']*1000).format('YYYY-MM-DD')
    },
    courseStartTime:function(){
      //团课上课时间
      return moment(this.order.courseStartTime*1000).format('YYYY-MM-DD')
    },
    refundCreatedTime:function(){
      //退款申请时间
      return moment(this.order.refundCreatedTime*1000).format('YYYY-MM-DD HH:mm:ss')
    },
    refundTime:function(){      
      //退款完成
      return moment(this.order.refundTime*1000).format('YYYY-MM-DD HH:mm:ss')
    },
    payment: function(){
      // 支付方式
      if(this.order.payment=='wxpay'){
        return "微信支付"
      }else if(this.order.payment=='alipay'){
        return "支付宝支付"
      }else{
        return ''
      }
    },
    ordertype: function(){
      //订单类型
      if(this.order.targetType=='clubGroupCourse'){
        return "俱乐部团体课"
      }else if(this.order.targetType=='clubPtCourse'){        
        return "教练私教课"
      }else if(this.order.targetType=='clubPracticeCard'){        
        return '俱乐部练球卡'
      }else if(this.order.targetType=='clubMonthCard'){        
        this.ordertypeInfo = true   //月卡不支持7天退换
        return '俱乐部包月卡'
      }else{
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-item{
    padding: .15rem;
    background-color:white;
    &__hd,&__bd{
        border-bottom: .01rem #f6f6f6 solid;
        & .tag{
          margin-left: -0.15rem;
        }
        &>.created{
          color: #F4B53A;
        }
        &>.paid{
          color:#06bf04;
        }
        &>.refunding,&>.refunded{
          color: red;
        }
    }
    &__bd{
      & .rili{
        font-size: 0.8rem;
        color:#ddd
      }
    }
}
// 用户信息
.buyed-users {
    width: 80%;
    height: 100%;
    &__item {
        border-bottom: 0.01rem #f6f6f6 solid;
        padding: 0.15rem;
    }
    &__info {
        overflow: hidden;
    }
}

// .buybar{
//     height: .51rem;
// }
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ManageOrderView.vue